import React from 'react'
import Navbar from '../components/general/Navbar'

function SetUpPage() {
  return (
    <div>
        <Navbar />
        Set up with email and JWT and stuff
    </div>
  )
}

export default SetUpPage